import { CSSProperties, ReactNode, useId } from 'react';
import CustomTooltip from './Tooltip';
import styles from './HoverHint.module.css';

interface HoverHintProps {
  /** What the hover says. Nothing - no tooltip, the children render as they are. */
  hint?: ReactNode;
  children: ReactNode;
  /** The wrapping element: a div where the children are blocks (a cell's two lines), a span inline. */
  as?: 'span' | 'div';
  className?: string;
  style?: CSSProperties;
  placement?: 'top' | 'bottom';
}

/**
 * The site's own tooltip (white card, shadow, arrow) around anything, instead of the browser's
 * grey `title` box. The hint's content is mounted only while it shows, so a hint that fetches
 * what it says (the names behind «4 פרויקטים») fetches on hover, not for every row.
 */
const HoverHint = ({ hint, children, as = 'span', className, style, placement = 'top' }: HoverHintProps) => {
  const id = useId();
  const Tag = as;
  if (hint === undefined || hint === null || hint === '') {
    return <Tag className={className} style={style}>{children}</Tag>;
  }
  return (
    <>
      <Tag id={id} className={className} style={style}>
        {children}
      </Tag>
      <CustomTooltip targetId={id} placement={placement}>
        <div className={styles.hint}>{hint}</div>
      </CustomTooltip>
    </>
  );
};

export default HoverHint;
